<template>
  <div class="emh-ui-image-loader">
    <wb-skeleton v-if="!loaded" class="emh-ui-image-loader__skeleton"></wb-skeleton>
    <div v-show="loaded" class="emh-ui-image-loader__image-container" @load.capture="setLoaded">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
export default { name: 'UiImageLoader' };
</script>

<script lang="ts" setup>
import { ref } from 'vue';

const loaded = ref<boolean>(false);

const setLoaded = () => {
  loaded.value = true;
};
</script>

<style lang="scss" scoped>
.emh-ui-image-loader {
  &__skeleton {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
